import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const SportParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Sport Parliament" />;
};

export default SportParliament;
